import { typeOf } from '.';

export const hasProperties = value => Object.keys(value).length > 0;

export function isObject(value, checkValue) {
  return (
    typeOf(value) === 'object' && (checkValue ? hasProperties(value) : true)
  );
}
